import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import cookie from '../util/cookie';
import request from './request';
import env from './env';
var PLATFORM = {
  iphone: 7,
  aphone: 8,
  ipad: 5,
  apad: 6,
  web: 1000,
  windows: 2000,
  mac: 2001,
  h5: 3000
};

function getPlatForm() {
  if (env.isApp && PLATFORM[env.device]) {
    return PLATFORM[env.device];
  }

  if (env.isWeb) {
    return PLATFORM.web;
  }

  return PLATFORM.h5;
}

export function getMainUserInfo() {
  var loginType = cookie.get('main_login');
  if (!loginType) return Promise.resolve(null);
  var userInfo = {
    type: loginType,
    nick: cookie.get("".concat(loginType, "_nick")),
    headurl: cookie.get("".concat(loginType, "_head"))
  };

  try {
    userInfo.nick = decodeURIComponent(userInfo.nick);
    userInfo.headurl = decodeURIComponent(userInfo.headurl);
  } catch (e) {}

  return Promise.resolve(userInfo);
}
export function getPayVip() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (param && param.service === 'kid') {
    return getKidPayVip();
  } // 支付查多个会员类型, 如 getPayVip({ viptype: ['nba']})


  var viptype = ['svip'];

  if (Array.isArray(param.viptype)) {
    viptype = viptype.concat(param.viptype);
  } else if (typeof param.viptype === 'string') {
    viptype.push(param.viptype);
  }

  return request('https://vip.video.qq.com/rpc/trpc.query_vipinfo.vipinfo.QueryVipInfo/GetVipUserInfoH5', {
    geticon: 1,
    // 身份位改造，通过此字段同步回来
    viptype: viptype.join('|'),
    platform: getPlatForm()
  }, {
    type: 'post',
    contentType: 'text/plain;charset=UTF-8',
    xhrFields: {
      withCredentials: true
    },
    timeout: 5000
  }).then(function (res) {
    if (res && res.result && res.result.code === 0) {
      return res;
    } else {
      throw res.result;
    }
  }).catch(function (e, xhr) {
    var err = {
      code: e ? e.code || -999 : 502,
      msg: e.msg || '[request] payvip error'
    };
    throw err;
  });
} // 获取小企鹅会员信息

function getKidPayVip() {
  var options = {
    type: 'post',
    dataType: 'json',
    xhrFields: {
      withCredentials: true
    }
  };
  return request('https://vip.video.qq.com/rpc/trpc.kidsvip.getvipinfo.KidsVipInfoService/KidsVipGetInfo', {}, options).then(function (res) {
    if (res && res.result && res.result.code === 0) {
      return res;
    } else {
      throw res.result;
    }
  }).catch(function (e) {
    var err = {
      code: e.code || -999,
      msg: e.msg || '[request] payvip error'
    };
    throw err;
  });
}